{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(立省 {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} 天免費",
    "{amount} off": "{amount} 優惠",
    "{amount} off for first {number} months.": "前 {number} 個月有 {amount} 折扣優惠",
    "{amount} off for first {period}.": "首{period}享 {amount} 折扣優惠",
    "{amount} off forever.": "永久享 {amount} 折扣優惠",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "{buyerName} 贈送了您 {siteTitle} 的 <strong>{duration} 個月</strong> {tierName} 會員資格",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "{buyerName} 贈送了您 {siteTitle} 的 <strong>{duration} 年</strong> {tierName} 會員資格",
    "{discount}% discount": "{discount}% 折扣",
    "{duration} membership": "{duration} 會員資格",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} 將不再收到{newsletterName}的電子報。",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} 將不會再收到評論回覆提醒郵件。",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} 將不會再收到該電子報。",
    "{memberEmail} will no longer receive updates & announcements.": "{memberEmail} 將不再收到更新與公告。",
    "{months} month": "{months} 個月",
    "{months} months": "{months} 個月",
    "{months} months free": "{months} 個月免費",
    "{tierName} membership": "{tierName} 會員資格",
    "{trialDays} days free": "{trialDays} 天免費試用",
    "{years} years": "{years} 年",
    "+1 (123) 456-7890": "0912-123-123",
    "1 month": "1 個月",
    "1 month free": "1 個月免費",
    "1 year": "1 年",
    "A gift, just for you": "專屬於您的禮物",
    "Access your RSS feeds": "存取您的 RSS 訂閱源",
    "Account": "帳號",
    "Account details updated successfully": "帳號資訊已更新成功",
    "Account settings": "帳號設定",
    "Add a personal note": "新增個人備註",
    "Add a short note to go with your gift": "新增附言隨禮物一同送出",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "免費試用結束後，您將支付所選方案的定價金額。在此之前，您可以隨時取消。",
    "Already a member?": "已經是會員了？",
    "An error occurred": "錯誤發生",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "發生了意外錯誤，請再試一次。如果錯誤持續出現，請<a>聯繫客服</a>。",
    "Back": "返回上一頁",
    "Back to Log in": "返回登入頁面",
    "Before you go": "在您離開前",
    "Billing info & receipts": "付款資訊與收據",
    "Black Friday": "黑色星期五促銷",
    "Bluesky": "",
    "Buy": "購買",
    "Buying for someone else?": "要送給其他人嗎？",
    "Cancel anytime.": "隨時取消",
    "Cancel subscription": "取消訂閱",
    "Canceled": "已取消",
    "Cancellation reason": "取消原因",
    "Change": "變更",
    "Change plan": "變更方案",
    "Check spam & promotions folders": "檢查垃圾郵件或促銷郵件",
    "Check with your mail provider": "請向您的電子郵件服務提供商確認",
    "Check your inbox to verify email update": "請檢查您的收件匣確認更新電子郵件",
    "Choose": "選擇",
    "Choose a date from today onwards": "請選擇今天或之後的日期",
    "Choose a date within the next year": "請選擇未來一年內的日期",
    "Choose a delivery date": "選擇送達日期",
    "Choose a different plan": "選擇其他方案",
    "Choose a plan": "選擇方案",
    "Choose a tier": "選擇方案",
    "Choose your newsletters": "選擇您的電子報",
    "City": "",
    "Click here to retry": "點擊重試",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "請點擊收件匣中的確認連結以完成會員兌換。若 3 分鐘內未收到，請檢查您的垃圾郵件匣。",
    "Close": "關閉",
    "Code": "驗證碼",
    "Comment preferences updated.": "留言偏好設定已更新。",
    "Comments": "留言",
    "Complimentary": "免費",
    "Confirm": "確認",
    "Confirm cancellation": "確認取消",
    "Confirm subscription": "確認訂閱",
    "Contact support": "聯繫客服",
    "Continue": "繼續",
    "Continue subscription": "繼續訂閱",
    "Continue to delivery details": "繼續填寫送達資訊",
    "Continue to payment": "繼續進行付款",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "您可以隨時續訂付費方案。您剩餘的贈送期間將轉換為免費試用天數。",
    "Copied": "已複製",
    "Copy": "複製",
    "Copy link": "複製連結",
    "Could not create Stripe billing portal session": "無法建立 Stripe 帳務管理入口連線",
    "Could not create Stripe checkout session": "無法建立 Stripe 結帳的連線",
    "Could not sign in. Login link expired.": "無法登入。登入連結已過期。",
    "Could not update email! Invalid link.": "無法更新電子郵件。連結無效。",
    "Country": "",
    "Create a new contact": "建立新的聯絡人",
    "Current plan": "目前方案",
    "Delete account": "刪除帳號",
    "Delivery date": "送達日期",
    "Delivery method": "送達方式",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "不小心按到？在<button>這裡</button>可以變更您的偏好設定。",
    "Don't have an account?": "還沒有帳號嗎？",
    "Edit": "編輯",
    "Email": "電子郵件",
    "Email confirmation link expired.": "電子郵件確認連結已過期。",
    "Email it to them": "透過電子郵件寄送給對方",
    "Email newsletter": "電子報",
    "Email newsletter settings updated": "電子報設定已更新",
    "Email preferences": "電子郵件偏好設定",
    "Email preferences updated.": "電子郵件偏好設定已更新。",
    "Emails": "電子郵件",
    "Emails disabled": "已停止接收電子郵件",
    "Ends {offerEndDate}": "於 {offerEndDate} 結束",
    "Enjoy {amountOff} off forever.": "永久享有 {amountOff} 折扣優惠。",
    "Enjoy {months} free months on us.": "免費贈送您 {months} 個月試用。",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "免費贈送您 {months} 個月試用。在 {newBillingDate} 之前不會向您收取費用。",
    "Enjoy a free month on us.": "免費贈送您 1 個月試用。",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "免費贈送您 1 個月試用。在 {newBillingDate} 之前不會向您收取費用。",
    "Enter code above": "輸入上方的驗證碼",
    "Enter the recipient's email address": "輸入收件者的電子郵件地址",
    "Enter your email address": "輸入你的電子郵件",
    "Enter your name": "輸入你的名字",
    "Error": "錯誤",
    "Expires {expiryDate}": "於 {expiryDate} 過期",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "取消訂閱失敗，請再試一次",
    "Failed to log in, please try again": "登入失敗，請再試一次",
    "Failed to log out, please try again": "登出失敗，請再試一次",
    "Failed to open billing portal, please try again": "無法開啟帳務管理入口，請再試一次",
    "Failed to process checkout, please try again": "結帳失敗，請再試一次",
    "Failed to send magic link email": "登入連結寄送失敗",
    "Failed to send verification email": "確認信寄送失敗",
    "Failed to sign up, please try again": "註冊失敗，請再試一次",
    "Failed to update account data": "更新帳號資訊失敗",
    "Failed to update account details": "更新帳號資訊失敗",
    "Failed to update billing information, please try again": "無法更新付款資訊，請再試一次",
    "Failed to update newsletter settings": "更新電子報設定失敗，請再試一次",
    "Failed to update subscription, please try again": "更新訂閱失敗，請再試一次",
    "Failed to verify code, please try again": "驗證碼驗證失敗，請再試一次",
    "For a friend or colleague": "送給朋友或同事",
    "Forever": "永久",
    "Free Trial – Ends {trialEnd}": "免費試用──於 {trialEnd} 結束",
    "From": "寄件者",
    "Get help": "取得協助",
    "Get in touch for help": "聯繫我們以取得協助",
    "Get notified when someone replies to your comment": "當有人回覆我的留言時通知我",
    "Gift a membership": "贈送會員資格",
    "Gift could not be redeemed": "無法兌換禮物",
    "Gift details": "禮物詳情",
    "Gift duration": "贈送期間",
    "Gift link copied to clipboard": "禮物連結已複製到剪貼簿",
    "Gift membership": "贈送會員資格",
    "Gift redeemed! You're all set.": "禮物已成功兌換！您已準備就緒。",
    "Gift subscription": "贈送訂閱方案",
    "Gift subscriptions are not available right now.": "目前暫不提供贈送訂閱方案。",
    "Gift value": "禮物價值",
    "Give feedback on this post": "為這篇文章提供意見",
    "Help! I'm not receiving emails": "求助！我沒有收到電子郵件",
    "Here are a few other sites you may enjoy.": "以下是您或許也有興趣的其他網站。",
    "Hi {recipientName},": "{recipientName} 您好，",
    "Hide details": "隱藏詳情",
    "How would you like to share this gift?": "您想如何分享這份禮物？",
    "I'll share it myself": "我會自行分享",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "如果有電子報被標記為垃圾郵件，您的電子郵箱地址將自動停止接收該電子報，以確保您不再收到任何不需要的訊息。",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "如果您不小心將電子報標示成垃圾郵件，或者您希望重新開始接收電子報，您可以點擊前一個畫面上的按鈕以重新訂閱電子報。",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "如果現在取消訂閱，您在 {periodEnd} 之前仍可存取內容。",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "如果您有企業或政府郵件帳戶，請聯繫相關 IT 部門，要求他們允許來自 {senderEmail} 的郵件。",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "登入連結已經發送到您的收件匣。如果在 3 分鐘內未收到，請務必檢查您的垃圾郵件。",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "一封電子郵件已發送至{submittedEmailOrInbox}。請點擊郵件內的連結，或輸入以下驗證碼。",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "如果您希望重新開始接收郵件，最好的方法是檢查您註冊的電子郵件地址是否正常運作，然後在前一個畫面點擊重新訂閱。",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "如果您沒有收到您訂閱的電子報，請檢查以下幾個事項。",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "如果您已經完成了上述所有檢查項目，但仍然沒有收到電子報，您可以透過聯繫 {supportAddress} 取得協助。",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "要是系統發送電子報時遇到永久失敗的情形，該帳號將停止接收電子報。",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "在您的電子郵件系統中將 {senderEmail} 加入您的聯絡人列表中。如此一來，您的電子郵件系統就會知道可以信任從該地址發送的郵件。",
    "Invalid email address": "無效的電子郵件地址",
    "Invalid verification code": "無效的驗證碼",
    "Jamie Larson": "阿宇",
    "jamie@example.com": "ayu@example.com",
    "Less like this": "減少相似內容",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "請確保郵件沒有意外地被歸類為垃圾郵件或促銷郵件。如果發生這類情形，請點擊「標記為非垃圾郵件」或「移至收件匣」。",
    "Manage": "管理",
    "Maybe later": "之後再說",
    "Membership details": "會員詳情",
    "Memberships from this email domain are currently restricted.": "目前不接受此電子郵件網域的會員申請。",
    "Memberships unavailable, contact the owner for access.": "目前無法提供會員資格，請聯絡網站擁有者以取得存取權限。",
    "month": "月",
    "Monthly": "每月",
    "More like this": "更多類似內容",
    "More options": "更多選項",
    "Name": "名字",
    "Need more help? Contact support": "需要更多協助？聯繫客服",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "您的帳號可能會因為兩個原因而停止接收電子報：先前的郵件被標記為垃圾郵件，或者嘗試發送郵件時出現永久失敗（郵件遭到退回）。",
    "No member exists with this e-mail address.": "沒有會員使用此電子郵件地址。",
    "No thanks, I want to cancel": "不用了，我想取消",
    "Not ready to share? We've also emailed a copy to your inbox.": "還不打算分享嗎？我們也已將副本發送至您的收件匣。",
    "Not receiving emails?": "沒有收到電子郵件？",
    "Now": "立即",
    "Now check your email!": "立即檢查您的電子郵件！",
    "Occasional updates from {siteTitle}": "來自 {siteTitle} 的不定期更新",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "重新訂閱後，如果您在收件夾中仍然看不到郵件，請檢查您的垃圾郵件匣。一些電子郵件服務商會保留先前的垃圾郵件記錄並持續標記此類郵件。如果發生這種情況，請將最新的電子報標記為「非垃圾郵件」，將其移回您的主要收件匣。",
    "Open AOL Mail": "開啟 AOL Mail",
    "Open email": "開啟電子郵件",
    "Open Feedbin": "開啟 Feedbin",
    "Open Gmail": "開啟 Gmail",
    "Open Hey": "開啟 Hey",
    "Open iCloud Mail": "開啟 iCloud Mail",
    "Open Mail.ru": "開啟 Mail.ru",
    "Open Outlook": "開啟 Outlook",
    "Open Proton Mail": "開啟 Proton Mail",
    "Open Yahoo Mail": "開啟 Yahoo Mail",
    "Optional message": "自訂訊息（選填）",
    "Permanent failure (bounce)": "永久錯誤 (郵件遭到退回)",
    "Phone number": "電話號碼",
    "Plan": "訂閱方案",
    "Plan checkout was cancelled.": "訂閱付款已取消。",
    "Plan upgrade was cancelled.": "訂閱升級已取消。",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "請聯絡 {supportAddress} 來調整你的免費的訂閱。",
    "Please enter {fieldName}": "請輸入{fieldName}",
    "Please fill in required fields": "請填寫必填項目",
    "Podcasts": "播客",
    "Postal code": "",
    "Re-enable emails": "重新啟用電子郵件",
    "Recipient's email": "收件者的電子郵件",
    "Recipient's name": "收件者的姓名",
    "Recommendations": "所有推薦",
    "Redeem your gift": "兌換您的禮物",
    "Redeeming...": "正在兌換...",
    "Renews at {price}.": "以 {price} 的價格續費。",
    "Resume subscription": "恢復訂閱",
    "Retry": "重試",
    "Save": "儲存",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "在接下來的{durationInMonths}個帳單週期中，每期可折抵{amountOff}。之後為每{cadence} {currency}{originalPrice}。",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "下期帳單可折抵{amountOff}。之後為每{cadence} {currency}{originalPrice}。",
    "Send the link below to share it with whoever you'd like.": "發送下方連結，即可與任何人分享。",
    "Sending login link...": "正在發送登入連結...",
    "Sending...": "發送中...",
    "Share": "分享",
    "Share a full membership to {siteTitle} with a friend or colleague": "與朋友或同事分享 {siteTitle} 的完整會員資格",
    "Share it yourself": "自行分享",
    "Show all": "顯示全部",
    "Sign in": "登入",
    "Sign out": "登出",
    "Sign up": "註冊",
    "Signup error: Invalid link": "註冊錯誤：連結無效",
    "Signups from this email domain are currently restricted.": "來自此電子郵件網域的註冊目前受到限制。",
    "Something went wrong, please try again later.": "伺服器錯誤，請稍後重試。",
    "Sorry, no paid plans are available.": "抱歉，目前沒有可用的付費方案。",
    "Sorry, no recommendations are available right now.": "抱歉，目前沒有其他的推薦。",
    "Sorry, that didn’t work.": "抱歉，該操作無法完成。",
    "Spam complaints": "垃圾郵件",
    "Start {amount}-day free trial": "開始 {amount} 天免費試用",
    "Starting {startDate}": "從 {startDate} 開始",
    "Starting today": "從今天開始",
    "State": "",
    "Submit feedback": "提交意見",
    "Subscribe": "訂閱",
    "Subscribed": "已訂閱",
    "Subscription plan updated successfully": "訂閱方案已成功更新",
    "Success": "成功",
    "Success! Check your email for magic link to sign-in.": "成功了！請檢查您的電子郵件以取得快速登入連結。",
    "Success! Your account is fully activated, you now have access to all content.": "成功了！您的帳號已完全啟用，您現在可以存取所有內容。",
    "Success! Your email is updated.": "成功了！您的電子郵件已更新。",
    "Successfully unsubscribed": "成功取消訂閱",
    "Taylor Reid": "阿宇",
    "taylor@example.com": "ayu@example.com",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "感謝您的訂閱，以下是一些你可能也會有興趣的網站。",
    "Thank you for your support": "感謝您的支持",
    "Thank you for your support!": "感謝您的支持！",
    "Thanks for the feedback!": "感謝您的意見！",
    "That didn't go to plan": "似乎出錯了",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "您的電子郵件地址是 {memberEmail} — 若不正確，您可在<button>帳號設定</button>中更新。",
    "There was a problem submitting your feedback. Please try again a little later.": "提交您的意見時遇到問題。請稍後再試。",
    "There was an error cancelling your subscription, please try again.": "取消您的訂閱時出現錯誤，請您再試一次。",
    "There was an error continuing your subscription, please try again.": "續約您的訂閱時出現錯誤，請您再試一次。",
    "There was an error processing your payment. Please try again.": "處理您的付款時出現錯誤，請您再試一次。",
    "There was an error sending the email, please try again": "發送電子郵件時出現錯誤，請您再試一次。",
    "This gift can only be redeemed once and expires on {expiryDate}.": "此禮物只能兌換一次，並將於 {expiryDate} 到期。",
    "This gift has already been consumed.": "此禮物已被使用。",
    "This gift has already been redeemed.": "此禮物已被兌換。",
    "This gift has been refunded.": "此禮物已退款。",
    "This gift has expired.": "此禮物已過期。",
    "This gift link is invalid.": "此禮物連結無效。",
    "This site is invite-only, contact the owner for access.": "此網站僅限邀請，請聯絡網站擁有者以取得存取權限。",
    "This site is not accepting donations at the moment.": "本網站目前不接受捐贈。",
    "This site is not accepting payments at the moment.": "本網站目前暫不接受付款。",
    "This site only accepts paid members.": "本網站僅允許付費會員。",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "方案",
    "To": "收件者",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "要完成註冊，請點擊您收件箱中的確認連結。如果在 3 分鐘內沒有收到，請檢查您的垃圾郵件!",
    "To continue to stay up to date, subscribe to {publication} below.": "訂閱 {publication} 以持續獲得最新消息。",
    "Too many attempts try again in {number} days.": "嘗試次數過多，請於 {number} 天後再試一次。",
    "Too many attempts try again in {number} hours.": "嘗試次數過多，請於 {number} 小時後再試一次。",
    "Too many attempts try again in {number} minutes.": "嘗試次數過多，請於 {number} 分鐘後再試一次。",
    "Too many different sign-in attempts, try again in {number} days": "登入嘗試次數過多，請於 {number} 日後再試一次。",
    "Too many different sign-in attempts, try again in {number} hours": "登入嘗試次數過多，請於 {number} 小時後再試一次。",
    "Too many different sign-in attempts, try again in {number} minutes": "登入嘗試次數過多，請於 {number} 分鐘後再試一次。",
    "Too many sign-up attempts, try again later": "註冊嘗試次數過多，請稍後重試。",
    "Try free for {amount} days, then {originalPrice}.": "免費試用 {amount} 天，然後以 {originalPrice} 開始訂閱。",
    "Unable to initiate checkout session": "無法建立結帳的連線",
    "Unlock access to all newsletters by becoming a paid subscriber.": "成為付費會員以解鎖所有電子報內容。",
    "Unsubscribe from all emails": "取消所有電子報訂閱",
    "Unsubscribed": "未訂閱",
    "Unsubscribed from all emails.": "未訂閱任何電子報。",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "取消接收電子報不會取消您對 {title} 的付費訂閱。",
    "Update": "更新",
    "Update your preferences": "更新您的偏好設定",
    "Updates & announcements": "更新與公告",
    "Verification link sent, check your inbox": "驗證連結已寄出，請確認你的信箱",
    "Verify your email address is correct": "確認你的 email 地址無誤",
    "Verifying...": "驗證中...",
    "View plans": "查詢訂閱方案",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "我們無法取消您的訂閱，因為找不到該電子郵箱地址。請聯繫網站擁有者。",
    "We'd hate to see you leave. How about a special offer to stay?": "我們很遺憾看到您離開。何不看看我們為您保留的專屬優惠？",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "我們將於 {deliveryDate} 透過電子郵件寄給收件者，同時也會寄一份副本到您的收件匣。",
    "We'll email it to the recipient. A copy will be in your inbox too.": "我們將透過電子郵件寄給收件者，同時也會寄一份副本到您的收件匣。",
    "Welcome back, {name}!": "歡迎回來，{name}！",
    "Welcome back!": "歡迎回來！",
    "Welcome to {siteTitle}": "歡迎來到{siteTitle}",
    "What's included": "包含內容",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "當收件箱無法接收郵件時，通常稱之為退信。在許多情況下，這可能是暫時的。然而，在某些情況下，當郵件地址無效或不存在時，退回的郵件可能會被視為永久失敗。",
    "Why has my email been disabled?": "為什麼我的電子郵件被停用了？",
    "X (Twitter)": "",
    "year": "年",
    "Yearly": "年付",
    "You already have an active subscription.": "您已擁有訂閱中的方案。",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "您目前是免費會員，升級至付費訂閱以獲得完整權限。",
    "You have been successfully resubscribed": "您已成功重新訂閱",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "您現在可以存取 {tierName} 內容至 {expiryDate}。盡情享受吧！",
    "You're currently not receiving emails": "您目前不會收到電子郵件。",
    "You're not receiving emails": "您當前不會收到電子郵件。",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "您無法接收郵件，可能是因為您最近將某個郵件標記為垃圾郵件，或者郵件無法發送到您提供的 email 地址。",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "您收到了一份 <strong>{duration} 個月</strong> {tierName} 會員資格禮物",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "您收到了一份 {siteTitle} 的 <strong>{duration} 個月</strong> {tierName} 會員資格禮物",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "您收到了一份 <strong>{duration} 年</strong> {tierName} 會員資格禮物",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "您收到了一份 {siteTitle} 的 <strong>{duration} 年</strong> {tierName} 會員資格禮物",
    "You've successfully signed in.": "您已成功登入。",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "您已經成功訂閱 <strong>{siteTitle}</strong>",
    "Your account": "您的帳號",
    "Your email": "您的電子郵件",
    "Your email has failed to resubscribe, please try again": "您的電子郵件重新訂閱失敗，請再試一次",
    "Your gift is on its way": "您的禮物已在路上",
    "Your gift is ready": "您的禮物已準備就緒",
    "Your gift is scheduled": "您的禮物已安排排程發送",
    "Your gift subscription will expire on {expiryDate}": "您的贈送訂閱方案將於 {expiryDate} 到期",
    "your inbox": "您的收件匣",
    "Your input helps shape what gets published.": "您的建議將使我們變得更好。",
    "Your name": "您的姓名",
    "Your subscription has been canceled and will expire on {expiryDate}.": "您的訂閱已取消，將於 {expiryDate} 到期。",
    "Your subscription will expire on {expiryDate}": "您的訂閱將於 {expiryDate} 到期",
    "Your subscription will renew on {renewalDate}": "您的訂閱將於 {renewalDate} 自動續訂",
    "Your subscription will start on {subscriptionStart}": "您的訂閱將於 {subscriptionStart} 開始"
}
